import { render, staticRenderFns } from "./WeatherWidgets.vue?vue&type=template&id=510bb137&scoped=true&"
import script from "./WeatherWidgets.vue?vue&type=script&lang=js&"
export * from "./WeatherWidgets.vue?vue&type=script&lang=js&"
import style0 from "./WeatherWidgets.vue?vue&type=style&index=0&id=510bb137&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510bb137",
  null
  
)

export default component.exports